<template>
    <header id="header" class="tra-menu white-scroll">
        <div class="header-wrapper">
            <HeaderPickleballLogo />
            <HeaderPickleballMenu />
        </div>
    </header>
</template>
